import React, {Fragment} from "react";
import {Dialog, Menu, Transition} from "@headlessui/react";
import {Navigate, useParams,} from "react-router-dom";
import {XCircleIcon, XIcon,} from "@heroicons/react/outline";
import {CheckCircleIcon, DotsVerticalIcon, ExclamationIcon,} from "@heroicons/react/solid";
import axios from "axios";



function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

class Invoiceview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sidebarOpen: false,
            setSidebarOpen: false,
            showmsg: false,
            logoutRedirect: false,
            opencustomer: false,
            openitem: false,
            invoice_date: '',
            invoice_house_id: '',
            invoice_due_date: '',
            invoice_total: '',
            invoice_payment_made: '',
            invoice_balance_due: '',
            invoice_notes: '',
            invoice_item: [
                {
                    name: "",
                    item_id: "",
                    description: "",
                    quantity: 1,
                    rate: 0,
                },
            ],
            ItemList: [{name: ''}],
            houseNumber: [],
            itemLine: [],
            error_list: [],
            paymentList: [],
            organizationProfile: '',
            items: [],
            query: "",
            queryItem: "",
            selectedPerson: "",
            loader: "",
            overLay: "",
            deletealartmsg: false,
            invoiceDetails: "",
            customerDetails: "",
            billingAddress: "",
            InvoicerecordpaymentEdit: "/crm/admin/invoicerecordpaymentedit/",
            invoiceEditlink: "/crm/admin/invoiceedit/",
            loader_status: false,
            try_again_status: false,
            main_content_status: false,

        };
    }

    setLoaderFunction = () => {

        this.setState({
            loader_status: true,
            try_again_status: false,
            main_content_status: false,
        });
    };
    closeLoaderFuncion = () => {
        this.setState({
            loader_status: false,
            try_again_status: false,
            main_content_status: true,
        });
    };

    enableTryAgain = () => {

        this.setState({
            loader_status: false,
            try_again_status: true,
            main_content_status: false,
        });
    };
    close = async (e) => {
        this.setState({sidebarOpen: false});
    };
    open = async (e) => {
        this.setState({sidebarOpen: true});
    };

    componentDidMount() {
        this.setLoaderFunction();
        const token = localStorage.getItem("token");
        const {id} = this.props.params;
        this.setState({invocieId: id});
        const ress = axios
            .get("api/invoice/edit/" + id, {
                headers: {
                    authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            })
            .then((ress) => {

                this.setState({
                    invoiceDetails: ress.data.invoice,
                    customerDetails: ress.data.invoice.primary_member,
                    billingAddress: ress.data.invoice.primary_member,
                    items: ress.data.invoice.invoice_item,
                    paymentList: ress.data.invoice.customer_payment_received,
                });

                this.state.paymentList = ress.data.invoice.customer_payment_received;
                this.setState({paymentList: this.state.paymentList});

            });


        const res = axios
            .get("api/invoice/url/for/create", {
                headers: {
                    authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            })
            .then((res) => {

                this.closeLoaderFuncion();
                this.setState({houseNumber: res.data.house_number});
                this.setState({ItemList: res.data.invoice_item});
                this.setState({organizationProfile: res.data.organizationProfile});
            });


        this.closeLoaderFuncion();
    }

    async componentDidMount() {

        this.getDataForPagination();
    
      }
    
    
      async getDataForPagination() {
        try {
          this.setLoaderFunction()
          const token = localStorage.getItem("token");
        const {id} = this.props.params;
        this.setState({invocieId: id});
          const [
    
            { data: edit },
            { data: create },
    
          ] = await Promise.all([
            axios.get("api/invoice/edit/" + id, { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),
            axios.get("api/invoice/url/for/create", { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),
            axios.get("api/invoice/edit/" + id, { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),
          ]);
    
    
          this.setState({
          });
          this.setState({
            invoiceDetails: edit.invoice,
            customerDetails: edit.invoice.primary_member,
            billingAddress:edit.invoice.primary_member,
            items:edit.invoice.invoice_item,
            paymentList:edit.invoice.customer_payment_received,
        });

        this.state.paymentList = edit.invoice.customer_payment_received;
        this.setState({paymentList: this.state.paymentList});

        this.setState({houseNumber:create.house_number});
        this.setState({ItemList:create.invoice_item});
        this.setState({organizationProfile:create.organizationProfile});

          this.closeLoaderFuncion();
    
        } catch (error) {
          this.enableTryAgain();
        }
      }
    
    
      tryAgain = () => {
            this.getDataForPagination();
      }

    delete = async (e) => {
        this.setState({deletealartmsg: true});
        this.setState({cryptKey: e});
    };

    haldleDelete = async (e) => {
        if (this.state.deletealartmsg) {
            const token = localStorage.getItem("token");
            let id = this.state.cryptKey;
            //const id=this.setState({cryptKey:e});
            const resDelete = axios
                .get("api/customer/payment/received/delete/" + id, {
                    headers: {
                        authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                })
                .then((resDelete) => {
                    if (resDelete.data.success) {
                        this.setState({deleteRedirect: true});
                        this.setState({deletealartmsg: false});
                    }
                });
        }
    };

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    recordPayment = (e) => {
        this.setState({recoerdpaymentredirect: true});
    };

    pdfDownload = (e) => {
        e.preventDefault();

        const token = localStorage.getItem("token");
        const {id} = this.props.params;

        const resspdf = axios
            .get("api/invoice/pdf/" + id, {
                headers: {
                    authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                responseType: "blob",
            })
            .then((resspdf) => {
                const url = window.URL.createObjectURL(new Blob([resspdf.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    this.state.invoiceDetails.invoice_number + ".pdf"
                ); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
    };

    saveassent = async (e) => {
        const token = localStorage.getItem("token");
        const {id} = this.props.params;
        const ressaveassent = axios
            .get("api/invoice/mark/as/sent/" + id, {
                headers: {
                    authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            })
            .then((ressaveassent) => {
                this.setState({icon: ressaveassent.data.success});
                if (ressaveassent.data.success) {
                    this.setState({message: "Successfully Saved"});
                    this.setState({showmsg: true});
                    setTimeout(
                        function () {
                            this.setState({showmsg: false}); //After 1 second, set render to true
                            this.setState({message: ""});
                        }.bind(this),
                        2000
                    );
                } else {
                    if (ressaveassent.data.data != undefined) {
                        this.state.error_list = ressaveassent.data.data;
                        this.setState({error_list: this.state.error_list});
                    } else {
                        this.state.error_list = null;
                        this.setState({error_list: this.state.error_list});
                        this.state.message = ressaveassent.data.message;
                        this.setState({message: this.state.message});
                        this.setState({showmsg: true});

                        setTimeout(
                            function () {
                                this.setState({showmsg: false});
                            }.bind(this),
                            1000
                        );
                    }
                }
            });
    };

    invoiceViewNullfunction = (e) => {
        if (e == null) {
            return " ";
        } else {
            return e;
        }
    };

    invoiceViewNullfunctionState = (e) => {
        if (e == null) {
            return " ";
        } else {
            if (e.name == null) {
                return "";
            } else {
                return e.name;
            }
        }
    };

    invoiceViewNullfunctionCountry = (e) => {
        if (e == null) {
            return " ";
        } else {
            if (e.name == null) {
                return "";
            } else {
                return e.name;
            }
        }
    };

    invoiceViewNullfunctionTin = (e) => {
        if (e == null) {
            return " ";
        } else {
            if (e.tin_number == null) {
                return "";
            } else {
                return e.tin_number;
            }
        }
    };
    //Logout function

    logout = async (e) => {
        e.preventDefault();
        var token = localStorage.getItem("token");

        const res = await axios.get("api/logout", {
            headers: {
                authorization: `Bearer ${token}`,
                Accept: "application/json",
            },
        });
        if (res.data.success) {
            localStorage.removeItem("token");
            this.setState({logoutRedirect: true});
        }
    };

    //Logout function

    render() {
        if (this.state.recoerdpaymentredirect) {
            const {id} = this.props.params;

            return <Navigate to={"/admin/invoice/record/payment/" + id}/>;
        }

        let token = localStorage.getItem("token");

        if (token == null) {
            return <Navigate to={"/Login"}/>;
        }

        if (this.state.logoutRedirect) {
            return <Navigate to={"/Login"}/>;
        }

        if (this.state.redirect) {
            return <Navigate to={"/itemList"}/>;
        }
        if (this.state.deleteRedirect) {
            window.location.reload();
        }

        return (
            <>
                {/*
            This example requires updating your template:

            ```
            <html className="h-full bg-gray-100">
            <body className="h-full">
            ```
          */}
                <div>
                    <div aria-hidden="true"/>

                  {/*loader_status------------------------------------------------------------------------*/}
           {this.state.loader_status && (
                    <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
                        <div className="bg-white p-4 rounded-md">
                            <div className="flex items-center justify-center">
                                <div
                                    className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                            </div>
                            <p className="text-center mt-4">Loading...</p>
                        </div>
                    </div>
                )}
                {/*loader_status------------------------------------------------------------------------*/}

                {/*try_again_status-----------------------------------------------------------------------------*/}
                {this.state.try_again_status && (
                    <div className="h-screen flex items-center justify-center bg-white ">
                        <div className="flex flex-col items-center justify-center h-full">
                            <p className="text-red-500">{this.state.error_customize}</p>
                            <button
                                type="button"
                                onClick={this.tryAgain}
                                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                                TryAgain
                            </button>
                        </div>
                    </div>
                )}
                {/*try_again_status-----------------------------------------------------------------------------*/}





                {this.state.main_content_status && (

                    <div className="flex flex-col flex-1">

                        <main className="flex-1">
                            <div className="py-6">
                                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                                    <div className="flex flex-row">
                                        <div className="basis-1/4">
                                            {" "}
                                            <h1 className="text-2xl font-semibold text-gray-900">
                                                View Due
                                            </h1>
                                        </div>
                                        <div className="basis-1/4"></div>
                                        <div className="basis-1/4"></div>
                                        <div className="basis-1/4 place-content-end">
                                            <Menu
                                                as="div"
                                                className="ml-3 relative inline-block text-left"
                                            >
                                                <div>
                                                    <Menu.Button
                                                        className="-my-2 p-2 rounded-full bg-white flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500">
                                                        <span className="sr-only">Open options</span>
                                                        <DotsVerticalIcon
                                                            className="h-5 w-5"
                                                            aria-hidden="true"
                                                        />
                                                    </Menu.Button>
                                                </div>

                                                <Transition
                                                    as={Fragment}
                                                    enter="transition ease-out duration-100"
                                                    enterFrom="transform opacity-0 scale-95"
                                                    enterTo="transform opacity-100 scale-100"
                                                    leave="transition ease-in duration-75"
                                                    leaveFrom="transform opacity-100 scale-100"
                                                    leaveTo="transform opacity-0 scale-95"
                                                >
                                                    <Menu.Items
                                                        className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                        <div className="py-1">
                                                            <Menu.Item>
                                                                {({active}) => (
                                                                    <a
                                                                        href="#"
                                                                        onClick={this.pdfDownload}
                                                                        target="__blank"
                                                                        className={classNames(
                                                                            active
                                                                                ? "bg-gray-100 text-gray-900"
                                                                                : "text-gray-700",
                                                                            "flex justify-between px-4 py-2 text-sm"
                                                                        )}
                                                                    >
                                                                        <span>Download Pdf</span>
                                                                    </a>
                                                                )}
                                                            </Menu.Item>
                                                            <Menu.Item>
                                                                {({active}) => (
                                                                    <a
                                                                        href={
                                                                            this.state.invoiceEditlink + this.state.invocieId
                                                                        }
                                                                        className={classNames(
                                                                            active
                                                                                ? "bg-gray-100 text-gray-900"
                                                                                : "text-gray-700",
                                                                            "flex justify-between px-4 py-2 text-sm"
                                                                        )}
                                                                    >
                                                                        <span>Edit</span>
                                                                    </a>
                                                                )}
                                                            </Menu.Item>
                                                            <Menu.Item>
                                                                {({active}) => (
                                                                    <button
                                                                        type="button"
                                                                        onClick={this.recordPayment}
                                                                        className={classNames(
                                                                            active
                                                                                ? "bg-gray-100 text-gray-900"
                                                                                : "text-gray-700",
                                                                            "w-full flex justify-between px-4 py-2 text-sm"
                                                                        )}
                                                                    >
                                                                        <span>Record Payment</span>
                                                                    </button>
                                                                )}
                                                            </Menu.Item>
                                                            <Menu.Item>
                                                                {({active}) => (
                                                                    <a
                                                                        href="#"
                                                                        onClick={this.saveassent}
                                                                        className={classNames(
                                                                            active
                                                                                ? "bg-gray-100 text-gray-900"
                                                                                : "text-gray-700",
                                                                            "flex justify-between px-4 py-2 text-sm"
                                                                        )}
                                                                    >
                                                                        <span>Save as Sent</span>
                                                                    </a>
                                                                )}
                                                            </Menu.Item>
                                                        </div>
                                                    </Menu.Items>
                                                </Transition>
                                            </Menu>
                                        </div>
                                    </div>
                                </div>
                                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                                    {/* Replace with your content */}

                                    <div className="hidden sm:block" aria-hidden="true">
                                        <div className="py-5">
                                            <div className="border-t border-gray-200"/>
                                        </div>
                                    </div>

                                    <div className="mt-10 sm:mt-0">
                                        <div className={`md:grid md:gap-6 ${this.state.loader}`}>
                                            <div className="mt-5 md:mt-0 md:col-span-2">
                                                <form onSubmit={this.udpateItem}>
                                                    <div className="shadow overflow-hidden sm:rounded-md">
                                                        <div className="px-4 py-5 bg-white sm:p-6">
                                                            <div className="px-4 sm:px-6 lg:px-8">
                                                                <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                                                                    <div className="sm:col-span-1">
                                                                        <dt className="text-sm font-medium text-gray-500">
                                                                            From <br/>

                                                                        </dt>
                                                                        <dd className="mt-1 text-sm text-gray-900">
                                                                            {this.state.organizationProfile?.name}<br/>
                                                                            {this.state.organizationProfile?.street_one}<br/>
                                                                            {this.state.organizationProfile?.street_two}<br/>
                                                                            {this.state.organizationProfile?.city}<br/>
                                                                            {this.state.organizationProfile?.zip_postal_code}
                                                                        </dd>

                                                                    </div>
                                                                    <div className="sm:col-span-1 text-right	">
                                                                        <dt className="text-sm font-medium text-gray-500">
                                                                            Due
                                                                        </dt>
                                                                        <dd className="mt-1 text-sm text-gray-900">
                                                                            {
                                                                                this.state.invoiceDetails?.invoice_number
                                                                            }
                                                                        </dd>
                                                                        <dd className="mt-1 text-sm text-gray-900">
                                                                            Balance Due
                                                                        </dd>
                                                                        <dd className="mt-1 text-sm text-gray-900">
                                                                            ₹ {this.state.invoiceDetails?.invoice_balance_due}
                                                                        </dd>
                                                                    </div>
                                                                    <div className="sm:col-span-1">
                                                                        <dt className="text-sm font-medium text-gray-500">
                                                                            {" "}
                                                                            Bill To
                                                                        </dt>
                                                                        <dd className="mt-1 text-sm text-gray-900">
                                                                            {this.state.customerDetails?.primary_contact_first_name}
                                                                        </dd>
                                                                        <dd className="mt-1 text-sm text-gray-900">
                                                                            {this.state.invoiceDetails?.invoice_house?.house_number}
                                                                        </dd>
                                                                        <dd className="mt-1 text-sm text-gray-900">
                                                                            {this.state.organizationProfile?.street_one}<br/>
                                                                            {this.state.organizationProfile?.street_two}<br/>
                                                                            {this.state.organizationProfile?.city}<br/>
                                                                            {this.state.organizationProfile?.zip_postal_code}
                                                                        </dd>


                                                                    </div>
                                                                    <div className="sm:col-span-1 text-right	">
                                                                        <dt className="text-sm font-medium text-gray-500">
                                                                            Due Created Date
                                                                            :{this.state.invoiceDetails?.invoice_date}

                                                                        </dt>

                                                                        <dd className="mt-1 text-sm text-gray-900">
                                                                            Due Date
                                                                            :{this.state.invoiceDetails?.invoice_due_date}

                                                                        </dd>
                                                                        <dd className="mt-1 text-sm text-gray-900"></dd>
                                                                    </div>


                                                                </dl>


                                                                <div className="mt-8 sm:flex sm:items-center">
                                                                    <div className="sm:flex-auto">
                                                                        <h1 className="text-xl font-semibold text-gray-900"></h1>
                                                                        <p className="mt-2 text-sm text-gray-700">
                                                                            <time dateTime="2022-08-01"></time>
                                                                            <time dateTime="2022-08-31"></time>
                                                                        </p>
                                                                    </div>
                                                                    <div
                                                                        className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none"></div>
                                                                </div>
                                                                <div
                                                                    className="-mx-4 mt-8 flex flex-col sm:-mx-6 md:mx-0">
                                                                    <table
                                                                        className="min-w-full divide-y divide-gray-300">
                                                                        <thead>
                                                                        <tr>
                                                                            <th
                                                                                scope="col"
                                                                                className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                                                            >
                                                                                Fee & Description
                                                                            </th>


                                                                            <th
                                                                                scope="col"
                                                                                className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                                                            >
                                                                                HouseNumber
                                                                            </th>

                                                                            <th
                                                                                scope="col"
                                                                                className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                                                            >
                                                                                Amount
                                                                            </th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {this.state.items.map((item) => (
                                                                            <tr
                                                                                key={item.id}
                                                                                className="border-b border-gray-200"
                                                                            >
                                                                                <td className="py-4 pl-4 pr-3 text-sm sm:pl-6 md:pl-0">
                                                                                    <div
                                                                                        className="font-medium text-gray-900">
                                                                                        {item.name}
                                                                                        <br/>
                                                                                        <span
                                                                                            className="text-gray-500 text-sm">
                                                {item.description}
                                              </span>
                                                                                    </div>
                                                                                    <div
                                                                                        className="mt-0.5 text-gray-500 sm:hidden"></div>
                                                                                </td>

                                                                                <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">

                                                                                    {this.state.invoiceDetails?.invoice_house?.house_number}
                                                                                </td>


                                                                                <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                                                                    {item.rate}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                        </tbody>
                                                                        <tfoot>


                                                                        <tr>
                                                                            <th
                                                                                scope="row"
                                                                                colSpan={5}
                                                                                className="hidden pl-6 pr-3 pt-4 text-right text-sm font-semibold text-gray-900 sm:table-cell md:pl-0"
                                                                            >
                                                                                Total
                                                                            </th>
                                                                            <th
                                                                                scope="row"
                                                                                className="pl-4 pr-3 pt-4 text-left text-sm font-semibold text-gray-900 sm:hidden"
                                                                            >
                                                                                Total
                                                                            </th>
                                                                            <td className="pl-3 pr-4 pt-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0">
                                                                                {this.state.invoiceDetails.invoice_total}
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th
                                                                                scope="row"
                                                                                colSpan={5}
                                                                                className="hidden pl-6 pr-3 pt-4 text-right text-sm font-semibold text-gray-900 sm:table-cell md:pl-0"
                                                                            >
                                                                                Balance Due
                                                                            </th>
                                                                            <th
                                                                                scope="row"
                                                                                className="pl-4 pr-3 pt-4 text-left text-sm font-semibold text-gray-900 sm:hidden"
                                                                            >
                                                                                Balance Due
                                                                            </th>
                                                                            <td className="pl-3 pr-4 pt-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0">
                                                                                {
                                                                                    this.state.invoiceDetails
                                                                                        .invoice_balance_due
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                        </tfoot>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mt-8 sm:flex sm:items-center">
                                                            <div className="sm:flex-auto">
                                                                <h1 className="text-xl font-semibold text-gray-900">Payment
                                                                    Details</h1>
                                                                <p className="mt-2 text-sm text-gray-700">
                                                                    <time dateTime="2022-08-01"></time>
                                                                    <time dateTime="2022-08-31"></time>
                                                                </p>
                                                            </div>
                                                            <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none"></div>
                                                        </div>
                                                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                                            <div className="col-span-6 sm:col-span-6 lg:col-span-6">
                                                                <div
                                                                    className="-mx-4 mt-8 flex flex-col sm:-mx-6 md:mx-0">
                                                                    <table
                                                                        className={`min-w-full divide-y divide-gray-300 ${this.state.loader}`}
                                                                    >
                                                                        <thead className="bg-gray-50">
                                                                        <tr>
                                                                            <th
                                                                                scope="col"
                                                                                className="py-3 pl-4 pr-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 sm:pl-6"
                                                                            >
                                                                                Date
                                                                            </th>

                                                                            <th
                                                                                scope="col"
                                                                                className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                                                            >
                                                                                Payment #
                                                                            </th>

                                                                            <th
                                                                                scope="col"
                                                                                className="px-3 py-3 text-left  text-xs font-medium uppercase tracking-wide text-gray-500"
                                                                            >
                                                                                Payment Mode
                                                                            </th>
                                                                            <th
                                                                                scope="col"
                                                                                className="px-3 py-3 text-left  text-xs font-medium uppercase tracking-wide text-gray-500"
                                                                            >
                                                                                Amount
                                                                            </th>
                                                                            <th
                                                                                scope="col"
                                                                                className="px-3 py-3 text-left  text-xs font-medium uppercase tracking-wide text-gray-500"
                                                                            >
                                                                                Action
                                                                            </th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            className="divide-y divide-gray-200 bg-white">
                                                                        {this.state.paymentList.map((person) => (
                                                                            <tr key={person.id}>
                                                                                <td className="whitespace-nowrap text-left px-3 py-4 text-sm text-gray-500">
                                                                                    {person.payment_date}
                                                                                </td>
                                                                                <td className="whitespace-nowrap text-left px-3 py-4 text-sm text-gray-500">
                                                                                    {"#"}{person.transaction_series_number}
                                                                                </td>

                                                                                <td className="whitespace-nowrap text-left px-3 py-4 text-sm text-gray-500">
                                                                                    {person.mode_of_payment.name}
                                                                                </td>
                                                                                <td className="whitespace-nowrap text-left px-3 py-4 text-sm text-gray-500">
                                                                                    {person.amount_received}
                                                                                </td>
                                                                                <td className="whitespace-nowrap text-left px-3 py-4 text-sm text-gray-500">
                                                                                    <a
                                                                                        href={
                                                                                            this.state.InvoicerecordpaymentEdit +
                                                                                            person.id_crypt
                                                                                        }
                                                                                    >
                                              <span
                                                  className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 cursor-pointer">
                                                Edit
                                              </span>
                                                                                    </a>
                                                                                    <span
                                                                                        onClick={() =>
                                                                                            this.delete(person.id_crypt)
                                                                                        }
                                                                                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-800 cursor-pointer"
                                                                                    >
                                              Delete
                                            </span>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    {/*DeleteAlert */}
                                    <Transition.Root
                                        show={this.state.deletealartmsg}
                                        as={Fragment}
                                    >
                                        <Dialog
                                            as="div"
                                            className="fixed z-10 inset-0 overflow-y-auto"
                                            onClose={() => this.setState({deletealartmsg: false})}
                                        >
                                            <div
                                                className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                                                <Transition.Child
                                                    as={Fragment}
                                                    enter="ease-out duration-300"
                                                    enterFrom="opacity-0"
                                                    enterTo="opacity-100"
                                                    leave="ease-in duration-200"
                                                    leaveFrom="opacity-100"
                                                    leaveTo="opacity-0"
                                                >
                                                    <Dialog.Overlay
                                                        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                                                </Transition.Child>

                                                {/* This element is to trick the browser into centering the modal contents. */}
                                                <span
                                                    className="hidden sm:inline-block sm:align-middle sm:h-screen"
                                                    aria-hidden="true"
                                                >
                          &#8203;
                        </span>
                                                <Transition.Child
                                                    as={Fragment}
                                                    enter="ease-out duration-300"
                                                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                                                    leave="ease-in duration-200"
                                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                                >
                                                    <div
                                                        className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                                                        <div
                                                            className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                                                            <button
                                                                type="button"
                                                                className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                                onClick={() =>
                                                                    this.setState({deletealartmsg: false})
                                                                }
                                                            >
                                                                <span className="sr-only">Close</span>
                                                                <XIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                        <div className="sm:flex sm:items-start">
                                                            <div
                                                                className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                                                <ExclamationIcon
                                                                    className="h-6 w-6 text-red-600"
                                                                    aria-hidden="true"
                                                                />
                                                            </div>
                                                            <div
                                                                className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                                <Dialog.Title
                                                                    as="h3"
                                                                    className="text-lg leading-6 font-medium text-gray-900"
                                                                >
                                                                    Delete Payment
                                                                </Dialog.Title>
                                                                <div className="mt-2">
                                                                    <p className="text-sm text-gray-500">
                                                                        Are you sure you want to delete the Payment
                                                                        Details ?
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                                            <button
                                                                type="button"
                                                                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                                                                onClick={this.haldleDelete}
                                                            >
                                                                Delete
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                                                                onClick={() =>
                                                                    this.setState({deletealartmsg: false})
                                                                }
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Transition.Child>
                                            </div>
                                        </Dialog>
                                    </Transition.Root>
                                    {/*End DeleteAlert */}


                                    {/* /End replace */}
                                </div>
                            </div>
                        </main>
                    </div>
                )}
                </div>

                <div
                    aria-live="assertive"
                    className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
                >
                    <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
                        {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                        <Transition
                            show={this.state.showmsg}
                            //show={true}
                            as={Fragment}
                            enter="transform ease-out duration-300 transition"
                            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div
                                className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                                <div className="p-4">
                                    <div className="flex">
                                        <div className="flex-shrink-0">
                                            {this.state.icon ? (
                                                <CheckCircleIcon
                                                    className="h-6 w-6 text-green-400"
                                                    aria-hidden="true"
                                                />
                                            ) : (
                                                <XCircleIcon
                                                    className="h-6 w-6 text-red-400"
                                                    aria-hidden="true"
                                                />
                                            )}
                                        </div>
                                        <div className="ml-3 w-0 flex-1 pt-0.5">
                                            <p className="text-sm font-medium text-gray-900">
                                                {this.state.message}
                                            </p>
                                            <p className="mt-1 text-sm text-gray-500"></p>
                                        </div>
                                        <div className="ml-4 flex-shrink-0 flex">
                                            <button
                                                className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                onClick={() => {
                                                    this.setState({showmsg: false});
                                                }}
                                            >
                                                <span className="sr-only">Close</span>
                                                <XIcon className="h-5 w-5" aria-hidden="true"/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition>
                    </div>
                </div>
            </>
        );
    }
}

export default (props) => <Invoiceview {...props} params={useParams()}/>;
